import { useProjectLimits } from '@api/limits';
import { AccessKeysTable } from '@components/AccessKeys';
import AccessKeyGenerationDialog from '@components/AccessKeys/Dialogs/GenerateDialog';
import AppHeader from '@components/AppNavigation/AppHeader';
import { CreateActionButton } from '@components/Buttons';
import { Box } from '@mui/system';
import { LimitType } from 'types/limits';
import { ACCESS_KEYS_FIELDS } from 'constants/global';
import React, { FC, useContext } from 'react';
import { ProjectContext } from 'routes/ProjectProvider';

const VISIBILITY_MODEL = {
	[ACCESS_KEYS_FIELDS.project]: false,
	[ACCESS_KEYS_FIELDS.hash]: false,
	[ACCESS_KEYS_FIELDS.version]: false,
	[ACCESS_KEYS_FIELDS.modifiedTime]: false,
	[ACCESS_KEYS_FIELDS.id]: false,
	[ACCESS_KEYS_FIELDS.permittedProjects]: false
};

const AccessKeysPage: FC = () => {
	const { currentProject } = useContext(ProjectContext);
	const { data: limits } = useProjectLimits(currentProject);
	const actions = React.useMemo(
		() => [
			<CreateActionButton
				key="add-access-key"
				Dialog={AccessKeyGenerationDialog}
				limitExceeded={limits?.accessKeyExceeded}
				limitType={LimitType.AccessKeys}
				buttonLabel={intl.tr('accessKeys.table.action.add.button')}
			/>
		],
		[limits]
	);

	return (
		<Box
			data-testid="access-keys-page"
			id="access-keys"
			display="flex"
			flexGrow={1}
			flexDirection="column"
			overflow="hidden"
		>
			<AppHeader translation="pages.accessKeys.title" />
			<AccessKeysTable
				columnVisibilityModel={VISIBILITY_MODEL}
				actions={actions}
			/>
		</Box>
	);
};

export default AccessKeysPage;
